/**
 * NotesCtrl controller
 * Show subscriber's notes
 */

import { NOTE_TYPES } from '../../app/core/constants'

/**
 * NotesCtrl controller
 *
 * @class NotesCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:NotesCtrl
 */
/* @ngInject */

export default function NotesCtrl ($uibModal, $scope, Note, AccessoryNote, Subscriber, authSvc, subscr, extra) {
  var vm = this
  vm.subscr = subscr
  vm.mixes = [['tabsCtrlMixin', 'general', 'accessory_purchasing']]

  vm.accessory_notes_statuses = {
    NOT_PROCESSED: 'Not Processed',
    PROCESSED: 'Processed',
    CANCELLED: 'Cancelled'
  }

  /**
   * Extra
   *
   * @memberof mwApp/subscribers.controller:NotesCtrl
   * @type {Object}
   */
  vm.extra = extra

  vm.noteTypes = NOTE_TYPES

  vm.noteTypesForFilter = Object.keys(NOTE_TYPES).map(key => ({ key, value: NOTE_TYPES[key].name }))

  vm.getNotes = function (tableState) {
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'createdTime'
      tableState.sort.reverse = false
    }
    Subscriber._getNotes(tableState, subscr.id)
      .then(data => {
        vm.notes = data.content.map(item => ({ ...item, typeName: NOTE_TYPES[item.type].name }))
      })
  }

  vm.getAccessoryNotes = function (tableState) {
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'createdTime'
      tableState.sort.reverse = false
    }
    Subscriber._getAccessoryNotes(tableState, subscr.id)
      .then(data => {
        vm.accessoryNotes = data.content
      })
  }

  vm.displayingAccessoryNames = function (note) {
    return note.accessories.map(a => a.name).join(', ')
  }

  /**
   * Create note
   *
   * @memberof mwApp/subscribers.controller:NotesCtrl
   * @function
   * @param  {models.Note} note
   * @param {Event} $event - jqLite event object
   * @param viewMode
   */
  vm.addNote = vm.editNote = function (note = null, viewMode = false, $event) {
    vm.stopEvent($event)

    var isNew = !note
    $uibModal.open({
      templateUrl: 'components/subscribers/views/addNote.html',
      controller: 'AddNoteCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        note: function () {
          return isNew ? new Note() : Note.load({ subscriber: subscr, id: note.id })
        },
        subscr: function () {
          return vm.subscr
        },
        viewMode: function () {
          return !!viewMode
        }
      }
    }).result
      .then(() => $scope.$broadcast('refreshTable'))
  }

  /**
   * Create note
   *
   * @memberof mwApp/subscribers.controller:NotesCtrl
   * @function
   * @param  {models.AccessoryNote} note
   * @param {Event} $event - jqLite event object
   * @param viewMode
   */
  vm.editAccessoryNote = function (note = null, viewMode = false, $event) {
    vm.stopEvent($event)

    var isNew = !note
    $uibModal.open({
      templateUrl: 'components/subscribers/views/editAccessoryNote.html',
      controller: 'EditAccessoryNoteCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        note: function () {
          return isNew ? new AccessoryNote() : AccessoryNote.load({ subscriber: subscr, accessoryNoteId: note.accessoryNoteId })
        },
        subscr: function () {
          return vm.subscr
        },
        viewMode: function () {
          return !!viewMode
        }
      }
    }).result
      .then(() => $scope.$broadcast('refreshTable'))
  }

  vm.openNoteUpdates = function (noteId, type) {
    $uibModal.open({
      templateUrl: 'components/subscribers/views/noteUpdates.html',
      controller: 'NoteUpdatesCtrl as vm',

      animation: false,
      size: 'xl',
      resolve: {
        noteId: function () {
          return noteId
        },
        subscriberId: function () {
          return vm.subscr.id
        },
        type: function () {
          return type
        }
      }
    })
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }
}
